import { useEffect, useState } from "react";

export default function Intro() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="intro" className="relative min-h-[92vh] flex items-center overflow-hidden bg-[#FAF7F2] pt-24 pb-16">
      <div className="absolute inset-0 pointer-events-none opacity-[0.045]">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="subtle-grid" x="0" y="0" width="92" height="92" patternUnits="userSpaceOnUse">
              <path d="M0 46h92M46 0v92" stroke="#B88734" strokeWidth="1" fill="none" />
              <circle cx="46" cy="46" r="2" fill="#B88734" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#subtle-grid)" />
        </svg>
      </div>

      <img
        src="/bp-logo.png"
        alt=""
        aria-hidden="true"
        className="hidden lg:block absolute right-24 top-36 w-72 opacity-[0.055] pointer-events-none"
      />

      <div
        className={`relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full transition-all duration-1000 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] xl:grid-cols-[1fr_390px] gap-12 lg:gap-16 items-center">
          <div className="max-w-3xl">
            <p className="text-[12px] uppercase tracking-[0.32em] text-[#B88734] mb-6" style={{ fontFamily: "'Lato', sans-serif" }}>
              01 / About
            </p>
            <h1
              className="font-serif text-5xl md:text-7xl text-[#2B1810] leading-[0.95] tracking-tight mb-7"
              style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: "-0.025em" }}
            >
              Navigating Systems,<br />Building Clarity
            </h1>
            <div className="w-16 h-px bg-[#B88734] mb-8" />
            <p className="text-[13px] md:text-sm uppercase tracking-[0.28em] text-[#B88734] mb-7" style={{ fontFamily: "'Lato', sans-serif" }}>
              Faith &bull; Purpose &bull; Creativity &bull; Impact
            </p>
            <p className="text-xl md:text-2xl text-[#2B1810]/80 font-serif mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Clarity in complexity. Structure with soul.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-[#2B1810]/78 max-w-2xl" style={{ fontFamily: "'Lato', sans-serif", letterSpacing: "normal" }}>
              I&apos;m Beatrice “Bea” Pate — a customs and trade compliance professional who turns messy systems into clearer, smarter, more usable processes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mt-9">
              <button
                onClick={() => document.querySelector("#work")?.scrollIntoView({ behavior: "smooth" })}
                className="px-8 py-3 bg-[#2B1810] text-[#FAF7F2] text-[13px] uppercase tracking-widest rounded-full hover:bg-[#B88734] hover:text-[#2B1810] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                View My Work
              </button>
              <button
                onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                className="px-8 py-3 border border-[#B88734] text-[#2B1810] text-[13px] uppercase tracking-widest rounded-full hover:bg-[#B88734]/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                Get In Touch
              </button>
            </div>
          </div>

          <aside className="max-w-[340px] mx-auto lg:mx-0 lg:justify-self-end">
            <div className="rounded-[2rem] bg-[#F8EFE2] border border-[#B88734]/25 p-4 shadow-[0_24px_60px_rgba(43,24,16,0.14)]">
              <img
                src="/bea-portrait.png"
                alt="Beatrice Bea Pate"
                className="w-full aspect-[4/5] object-cover object-[center_18%] rounded-[1.45rem]"
              />
            </div>
            <div className="mt-5 flex items-center justify-center gap-3 text-[#B88734]">
              <img src="/bp-bear-logo.png" alt="BP bear mark" className="h-10 w-10 object-contain" />
              <span className="text-[10px] uppercase tracking-[0.26em]" style={{ fontFamily: "'Lato', sans-serif" }}>
                BP Bear Mark
              </span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
